import type { TableRow } from '@/components/atoms/Table/Table.type';
import type { SortingRule } from 'react-table';

const sortByMapper: Record<string, string> = {
    name: 'name',
    status: 'is_active',
    source: 'brand_id',
    linkType: 'link_type',
};

export const convertTableSortToQuerySort = (sortBy?: SortingRule<TableRow>[]): string | undefined => {
    if (!sortBy?.length) {
        return undefined;
    }

    const sortByKey = sortBy[0].id;
    const column = sortByMapper[sortByKey] ?? sortByKey;

    return `${column} ${sortBy[0].desc ? 'DESC' : 'ASC'}`;
};
